import React, { useState } from 'react';
import { Button, Space } from 'antd';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import LayoutHeader from '../../components/LayoutHeader';
import { RootState } from '@store/index';
import ManagerTable from '@components/ManagerTable';
import { getManagers } from '@store/Actions/GetManagers';
import CreateManager from '@components/CreateManager';
import ManagerCard from '@components/ManagerCard';

import './index.css';

interface Props {
    screenWidth: number;
    getManagers: () => void;
}

const Managers: React.FC<Props> = ({
    screenWidth,
    getManagers,
}): JSX.Element => {
    const [modalVisible, setModalVisible] = useState<boolean>(false);

    const handleModal = (e) => {
        e.preventDefault();
        setModalVisible(true);
    };

    const closeModal = () => {
        setModalVisible(!modalVisible);
    };

    return (
        <div className="manager__container">
            <div className="manager__header">
                <LayoutHeader title="Usuarios" subTitle="Supervisor" />
                <Space>
                    <Button
                        type="default"
                        style={{ width: 50 }}
                        icon={<ReloadOutlined />}
                        onClick={() => getManagers()}
                    />

                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={(e) => {
                            handleModal(e);
                        }}
                        style={screenWidth <= 512 ? { width: 50 } : {}}
                    >
                        {screenWidth > 512 && 'Agregar Supervisor'}
                    </Button>
                </Space>
            </div>
            <CreateManager
                modalVisible={modalVisible}
                closeModal={closeModal}
            />
            {screenWidth > 635 ? <ManagerTable /> : <ManagerCard />}
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        screenWidth: state.ScreenResize.screenWidth,
    };
};

const mapDispatchToProps = {
    getManagers,
};

export default connect(mapStateToProps, mapDispatchToProps)(Managers);
